import { createContext } from 'react';

import { captureException } from '@sentry/react';

import { makeToast } from '@cognite/cogs-lab-v11';
import { useMetrics } from '@cognite/metrics';

import { useCurrentUserContext } from '../../../../providers/current-user-provider/current-user-provider';
import type { FDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { useFDMServices } from '../../../../providers/fdm-services/fdm-services.context';
import { useNetworkStatusContext } from '../../../../providers/network-status-provider/network-status-provider';

export type FDMServicesNumericReadingType = () => {
  measurementsService: Pick<
    FDMServices['measurementsService'],
    'updateMeasurements'
  >;
  timeseriesService: Pick<
    FDMServices['timeseriesService'],
    'insertDataPoint' | 'deleteDataPoint'
  >;
};

export interface UseMeasurementNumericReadingUpsertContextInterface {
  useFDMServices: FDMServicesNumericReadingType;
  useCurrentUserContext: () => Pick<
    ReturnType<typeof useCurrentUserContext>,
    'user'
  >;
  useNetworkStatusContext: () => Pick<
    ReturnType<typeof useNetworkStatusContext>,
    'isOnline'
  >;
  useMetrics: (
    ...args: Parameters<typeof useMetrics>
  ) => Pick<ReturnType<typeof useMetrics>, 'track'>;
  makeToast: typeof makeToast;
  captureException: typeof captureException;
}

export const defaultValue: UseMeasurementNumericReadingUpsertContextInterface =
  {
    useFDMServices,
    useCurrentUserContext,
    useNetworkStatusContext,
    useMetrics,
    makeToast,
    captureException,
  };

export const MeasurementNumericReadingUpsertContext =
  createContext<UseMeasurementNumericReadingUpsertContextInterface>(
    defaultValue
  );
